import { render, staticRenderFns } from "./Partner_Data.vue?vue&type=template&id=7661b83a&scoped=true&"
import script from "./Partner_Data.vue?vue&type=script&lang=js&"
export * from "./Partner_Data.vue?vue&type=script&lang=js&"
import style0 from "./Partner_Data.vue?vue&type=style&index=0&id=7661b83a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7661b83a",
  null
  
)

export default component.exports